import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = {
    resultsUrl: String,
  };

  select(event) {
    const url = new URL(this.resultsUrlValue);
    url.searchParams.set('map_type', event.target.value);

    Turbo.visit(url, { frame: 'risk-assessments-heatmap-results' });
  }
}
